import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import swal from "sweetalert";
import MainPagetitle from '../../layouts/MainPagetitle';
import PaymentDetailService from '../../api/services/PaymentDetailService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import { Modal, Button } from 'react-bootstrap';
import { downloadExcel } from 'react-export-table-to-excel';
import moment from 'moment';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const PaymentDetailList = () => {
    const [Error, setError] = useState('');
    const [startDate, setStartDate] = useState('');
    const [EndDate, setEndDate] = useState('');
    const [paymentStatus, setPaymentStatus] = useState("");
    const [PaymentList, setPaymentList] = useState([]);
    const [FilterModal, setFilterModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setisloading] = useState(true);
    const tableRef = useRef(null);
    const [packages, setpackages] = useState([]);
    const [cancaletions, setcancaletions] = useState([]);
    const [services, setservices] = useState([]);
    const [accessories, setaccessories] = useState([]);
    const [numberOfNight, setNumberOfNight] = useState([]);
    const [kilometer, setkilometer] = useState([]);
    const [problem_comment, setProblem_comment] = useState(-1)
    const [inputproblem, setInputProblem] = useState('');
    const [general_comment, setgeneral_comment] = useState(-1)
    const [inputgeneral, setInputgeneral] = useState('');
    const [tips_comment, settips_comment] = useState(-1)
    const [inputtip, setInputtip] = useState('');
    const [ResendModal, setResendModal] = useState(false);
    const [UpdateReview, setUpdateReview] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const recordsPage = 50000;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    // const records = PaymentList.slice(firstIndex, lastIndex);
    // const npage = Math.ceil(PaymentList.length / recordsPage)
    // const number = [...Array(npage + 1).keys()].slice(1)
    const records = Array.isArray(PaymentList) && PaymentList.length > 0
        ? PaymentList.slice(firstIndex, lastIndex)
        : [];

    const npage = Math.ceil((Array.isArray(PaymentList) ? PaymentList.length : 0) / recordsPage);
    const number = [...Array(npage + 1).keys()].slice(1);
    const navigate = useNavigate();

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }
    const currentYear = new Date().getFullYear(); // Get the current year
    // const startYear = currentYear; // 5 years before the current year
    const startYear = Math.min(currentYear, 2024); // Make sure 2024 is included

    const endYear = currentYear + 10; // 5 years after the current year
    const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
    const [selectedYear, setSelectedYear] = useState('');

    const [conflictModal, setConflictModal] = useState(false);
    const [conflictData, setConflictData] = useState(null);

    useEffect(() => {
        const currentYear = new Date().getFullYear(); // Get the current year

        if (currentYear >= startYear && currentYear <= endYear) {

            setSelectedYear(currentYear);
        } else {
            setSelectedYear('');
        }
        // getdashboardByYear();
    }, [currentYear, startYear, endYear]);


    const getPaymentList = async () => {

        try {
            var payload = {
                "year": currentYear,
            }
            let responseData = await PaymentDetailService.index(payload).json()

            setPaymentList(responseData.data)
            setpackages(responseData.packages)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setkilometer(responseData.kilometer)
            setNumberOfNight(responseData.number_of_night);
            setisloading(false)
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('admintoken')) {

            getPaymentList();

        }
        else {
            navigate('/');
        }

    }, [])
    const handleDelete = async (e) => {

        try {
            let responseData = await PaymentDetailService.destroy(e).json()
            if (responseData.status === true) {
                swal("Booking Delete Succesfully").then((willDelete) => {
                    if (willDelete) {
                        getPaymentList();
                    }
                })

            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    }

    const handleCancle = async (e) => {

        e.preventDefault();

        let order_id = e.target.id
        try {
            var userData = {
                "orderid": order_id,
            }
            let responseData = await PaymentDetailService.cancle(userData).json()
            if (responseData.status === true) {

            } else if (responseData.errortype === "date_conflict") {
                setConflictData(responseData.data);
                setConflictModal(true);
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    }
    const handleRefund = async (e) => {
        e.preventDefault();
        let payment_id = e.target.id


        try {
            var userData = {
                "paymentid": payment_id,
            }
            let responseData = await PaymentDetailService.refund(userData).json()
            console.log(responseData)
            if (responseData.status === true) {
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    }
    const handlePaidStatus = async (e) => {
        e.preventDefault();
        let payment_id = e.target.id
        try {
            var userData = {
                "paymentid": payment_id,
            }
            let responseData = await PaymentDetailService.updatepaidstatus(userData).json();
            if (responseData.status === true) {
                // alert('Updated!!!')
                getPaymentList();
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    const updatechecktatus = async (e) => {
        e.preventDefault();
        let userid = e.target.id
        try {
            var userData = {
                id: userid
            }
            let responseData = await PaymentDetailService.updatechecktatus(userData).json();
            let responseDataOrder = await PaymentDetailService.updateOrderstatus(userid).json();

            if (responseData.status === true || responseDataOrder.status == true) {

                // alert('Order has been updated!!!')
                getPaymentList();
                // window.location.reload();
            }

        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }

    }
    // const header = [
    //     "Checked", "Type", "Booking Number", "Camper Model", "Number Of Nights", "Carefree Package", "Cancellation Policy", "Services", "Accessoires", "Start Date", "End Date", "	Billing User Name", "Billing Email", "Billing Amount", "Pays Cash (COD)", "Payment Status", "First & Last Name", "Email", "Phone Number", "Date Of Birth", "Street, Address Addition, Zip", "City, Country", "VAT ID", "Company", "Voucher", "Problems", "General", "Tips"
    // ];

    // const tableData = Array.isArray(PaymentList) && PaymentList.length > 0
    //     ? PaymentList.map((row, index) =>
    //         header.map((nw, i) =>
    //             [nw === "Checked" ? row.ischecked === 0 ? "Not Checked" : row.ischecked === 1 ? "Checked" : 'Pending' : '',
    //             nw === "Type" ? row.camper_type_id === 1 ? "Rent" : row.camper_type_id === 2 ? "Subscription" : "Sale" : '',
    //             nw === "Booking Number" ? row.payment_order_id : '',
    //             nw === "Camper Model" ? row.camper_name : '',
    //             nw === "Number Of Nights" ? numberOfNight[index] : '',
    //             nw === "Carefree Package" ? packages[index] : '',
    //             nw === "Cancellation Policy" ? cancaletions[index] : '',
    //             nw === "Services" ? services[index] : '',
    //             nw === "Accessoires" ? accessories[index] : '',
    //             nw === "Start Date" ? row.start_date ? moment(row.start_date).format('DD.MM.YYYY HH:mm') : '' : '',
    //             nw === "End Date" ? row.end_date ? moment(row.end_date).format('DD.MM.YYYY HH:mm') : '' : '',
    //             nw === "Billing User Name" ? row.billing_user_name ? row.billing_user_name : '_' : '',
    //             nw === "Billing Email" ? row.billing_email ? row.billing_email : '-' : '',
    //             nw === "Billing Amount" ? row.billing_amount : '',
    //             nw === "Pays Cash (COD)" ? row.COD == 1 ? 'Yes' : 'No' : '',
    //             // nw === "Payment Status" ? row.Paid == 1 ? "Paid" : 'Unpaid' : '',
    //             nw === "Payment Status" ? row.Paid == 1 && row.COD == 0 ? 'Fully Paid  (Stripe)' : row.COD == 1 && row.Paid == 0 ? ' Not Paid' : row.Paid == 2 && row.COD == 1 ? 'Partially Paid' : row.COD == 1 && row.Paid == 3 ? 'Fully Paid (Manual)' : "" : "",
    //             nw === "First & Last Name" ? row.billing_user_name2 : '',
    //             nw === "Email" ? row.billing_email2 : '',
    //             nw === "Phone Number" ? row.phone : '',
    //             nw === "Date Of Birth" ? row.dob ? moment(row.dob).format('DD.MM.YYYY') : '' : '',
    //             nw === "Street, Address Addition, Zip" ? row.payment_order_id : '',
    //             nw === "City, Country" ? row.pstreet + "," + row.paddress + "," + row.pzip : '',
    //             nw === "VAT ID" ? row.pvat_id : '',
    //             nw === "Company" ? row.pcompany : '',
    //             nw === "Voucher" ? row.ovouchercode ? 'Yes' : "No" : '',
    //             nw === "Problems" ? row.problem_comment : '',
    //             nw === "General" ? row.general_comment : '',
    //             nw === "Tips" ? row.tips_comment : '']
    //         )
    //     ) : [];

    const header = [
    "Checked",
    "Deposit Received",
    "Type",
    "Booking Number",
    // "View Documents",
    "Camper Model",
    "License Plate",
    "Number Of Nights",
    "Carefree Package",
    "Cancellation Policy",
    "Services",
    "Accessoires",
    "Kilometer",
    "Start Date",
    "End Date",
    "Billing User Name",
    "Billing Email",
    "Billing Amount",
    "Pays Cash (COD)",
    "Payment Status",
    "First & Last Name",
    "Email",
    "Phone Number",
    "Date Of Birth",
    "Street, Address Addition, Zip",
    "City, Country",
    "VAT ID",
    "Company",
    "Created",
    "Order Date",
    "Voucher",
    "Resend",
    "Cancel / Refund / Delete",
    "Problems",
    "General",
    "Tips",
    "Satisfied",
    "Review Requested",
    "Reminder 2",
    "Review Submitted",
    "Deposit Refunded"
];

const tableData = Array.isArray(PaymentList) && PaymentList.length > 0
    ? PaymentList.map((row, index) =>
        header.map((nw) =>
            nw === "Checked"
                ? row.is_checked == 0
                    ? "Not Checked"
                    : row.is_checked == 1
                        ? "Checked"
                        : row.is_checked == 2
                            ? "Pending"
                            : ""

            : nw === "Deposit Received"
                ? row.deposit_received == 0
                    ? "Not received"
                    : "Received"

            : nw === "Type"
                ? row.camper_type_id === 1
                    ? "Rent"
                    : row.camper_type_id === 2
                        ? "Subscription"
                        : "Sale"

            : nw === "Booking Number"
                ? row.payment_order_id || ""

            // : nw === "View Documents"
            //     ? "View Documents"

            : nw === "Camper Model"
                ? row.camper_name || ""
            
            : nw === "License Plate"
                ? row.license_plate || ""       

            : nw === "Number Of Nights"
                ? numberOfNight[index] || ""

            : nw === "Carefree Package"
                ? packages[index] || ""

            : nw === "Cancellation Policy"
                ? cancaletions[index] || ""

            : nw === "Services"
                ? services[index] || ""

            : nw === "Accessoires"
                ? accessories[index] || ""

            : nw === "Kilometer"
                ? kilometer[index] || ""

            : nw === "Start Date"
                ? row.start_date
                    ? moment(row.start_date).format("DD.MM.YYYY HH:mm")
                    : ""

            : nw === "End Date"
                ? row.end_date
                    ? moment(row.end_date).format("DD.MM.YYYY HH:mm")
                    : ""

            : nw === "Billing User Name"
                ? row.billing_user_name
                    ? row.billing_user_name
                    : "-"

            : nw === "Billing Email"
                ? row.billing_email
                    ? row.billing_email
                    : "-"

            : nw === "Billing Amount"
                ? row.billing_amount ?? ""

            : nw === "Pays Cash (COD)"
                ? row.COD == 1
                    ? "Yes"
                    : "No"

            : nw === "Payment Status"
                ? row.Paid == 1 && row.COD == 0
                    ? "Fully Paid (Stripe)"
                    : row.Paid == 2 && row.COD == 1
                        ? "Partially Paid"
                        : row.COD == 1 && row.Paid == 3
                            ? "Fully Paid (Manual)"
                            : row.COD == 1 && row.Paid == 0
                                ? "Not Paid"
                                : ""

            : nw === "First & Last Name"
                ? row.billing_user_name2 || ""

            : nw === "Email"
                ? row.billing_email2 || ""

            : nw === "Phone Number"
                ? row.phone || ""

            : nw === "Date Of Birth"
                ? row.dob
                    ? moment(row.dob).format("DD.MM.YYYY")
                    : ""

            : nw === "Street, Address Addition, Zip"
                ? row.paddress || ""

            : nw === "City, Country"
                ? row.paddress_2 || ""

            : nw === "VAT ID"
                ? row.pvat_id || ""

            : nw === "Company"
                ? row.pcompany || ""

            : nw === "Created"
                ? row.order_created_at
                    ? moment(row.order_created_at).format("DD-MM-YYYY HH:mm")
                    : ""
    
            : nw === "Voucher"
                ? row.ovouchercode
                    ? `Yes - ${row.ovouchercode}`
                    : "No"

            : nw === "Resend"
                ? "Resend"

            : nw === "Cancel / Refund / Delete"
                ? `${row.is_cancellations == 0 ? "Cancel" : "Cancelled"} / ${row.is_refunds == 0 ? "Refund" : "Refunded"} / Delete`

            : nw === "Problems"
                ? row.problem_comment || ""

            : nw === "General"
                ? row.general_comment || ""

            : nw === "Tips"
                ? row.tips_comment || ""

            : nw === "Satisfied"
                ? row.is_satisfied == 0
                    ? "Yes"
                    : "No"

            : nw === "Review Requested"
                ? row.is_reviewed == 0
                    ? "Not Requested"
                    : "Requested"

            : nw === "Reminder 2"
                ? row.review_reminder_2 == 0
                    ? "Not Requested"
                    : "Requested"

            : nw === "Review Submitted"
                ? row.review_submitted == 0
                    ? "Not Submitted"
                    : "Submitted"

            : nw === "Deposit Refunded"
                ? row.deposit_refunded == 0
                    ? "Not Refunded"
                    : "Refunded"

            : ""
        )
    )
    : [];
    
    function useDownloadExcel() {
        downloadExcel({
            fileName: "Manage Booking",
            sheet: "Manage Booking",
            tablePayload: {
                header,
                // accept two different data structures
                // body: filteredList.filter((element) => { return element.firstname }),
                body: tableData
            },
        });
    }
    const handleProblem_comment = async (id, e, value) => {
        console.log(value, "tesrt")
        var userData = {}
        if (e === 'Problem_comment') {
            userData = {
                "problem_comment": inputproblem ? inputproblem : value,

            }
            setProblem_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "problem_comment", userData).json()
                if (responseData.status === true) {
                    alert("update")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }
        else if (e === "General_comment") {
            userData = {

                "general_comment": inputgeneral ? inputgeneral : value,

            }
            setgeneral_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "general_comment", userData).json()
                if (responseData.status === true) {
                    alert("update")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }
        else if (e === "tips_comment") {
            userData = {

                "tips_comment": inputtip ? inputtip : value,

            }
            settips_comment(-1)
            try {

                let responseData = await PaymentDetailService.updatecomments(id, "tips_comment", userData).json()
                if (responseData.status === true) {
                    alert("update")
                }
                getPaymentList();
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
                }
            }
        }



    }
    const handleResendConfirmation = async (bookingid) => {
        try {

            let responseData = await PaymentDetailService.resendBooking(bookingid).json()
            if (responseData.status === true) {
                setResendModal(true)
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to send email. Please try again.')
            }
        }
    }
    const handleReview = async (orderid) => {

        try {

            let responseData = await PaymentDetailService.updatereview(orderid).json()
            if (responseData.status === true) {
                setUpdateReview(true)
                setModalMessage("Review updated successfully.")
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }

    const handleSatisfied = async (orderid, type) => {

        try {
            const payload = {
                status: type
            }

            let responseData = await PaymentDetailService.updatesatisfied(orderid, payload).json()
            if (responseData.status === true) {
                setUpdateReview(true)
           
                setModalMessage("Satisfied status updated successfully.")
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }

    const handleReviewReminder = async (orderid, type) => {

        try {
            const payload = {
                status: type
            }

            let responseData = await PaymentDetailService.updateReviewReminder(orderid, payload).json()
            if (responseData.status === true) {
                setUpdateReview(true)
                setModalMessage("Review reminder updated successfully.")
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }
 
    const handleReviewSubmit = async (orderid, type) => {

        try {
              const payload = {
                status: type
            }

            let responseData = await PaymentDetailService.updateReviewSubmitted(orderid, payload).json()
            if (responseData.status === true) {
                setUpdateReview(true)
                setModalMessage("Review submitted updated successfully.")
            }
            getPaymentList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }

    const handleDepositRefund = async (orderid, type) => {

        try {
             const payload = {
                status: type
            }

            let responseData = await PaymentDetailService.updateDepositRefunded(orderid, payload).json()
            if (responseData.status === true) {
                setUpdateReview(true)
                setModalMessage("Deposit refunded updated successfully.")
                getPaymentList();
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError('Failed to update review. Please try again.')
            }
        }
    }





    // Handle year change
    const getdashboardByYear = async (event) => {
        const year = event?.target?.value;
        try {
            var payload = {
                "year": year ? year : '',
            }
            let responseData = await PaymentDetailService.index(payload).json()

            setPaymentList(responseData.data)
            setpackages(responseData.packages)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setkilometer(responseData.kilometer)
            setNumberOfNight(responseData.number_of_night);
            setisloading(false)
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message)
            }
        }
    };
    const handlePaymentStatusChange = (e) => {
        setPaymentStatus(e.target.value); // Update state when a new value is selected
    }
    const onSubmitFilterForm = async (event) => {
        setisloading(true)
        event.preventDefault();
        try {
            var userData = {
                "start_date": event.target.start_date.value,
                "end_date": event.target.end_date.value,
                // "email": event.target.email.value,
                "payment_status": paymentStatus ? paymentStatus : ""
            }
            var startDate = new Date(userData.start_date);
            var endDate = new Date(userData.end_date);
            if (startDate > endDate) {
                setError("The Start Date cannot be later than the End Date.");
                return; // Exit the function if the dates are not valid
            }
            else {
                let responseData = await PaymentDetailService.index(userData).json()
                setPaymentList(responseData.data)
                setpackages(responseData.packages)
                setcancaletions(responseData.cancaletions)
                setservices(responseData.services)
                setaccessories(responseData.accessories)
                setkilometer(responseData.kilometer)
                setNumberOfNight(responseData.number_of_night);
                setFilterModal(false)
                setisloading(false)
            }
        } catch (error) {
            alert("An Error Occured.")
        }
    }
    const resetfilter = async () => {
        setisloading(true)
        setSelectedYear('')
        setStartDate("")
        setEndDate("")
        setPaymentStatus("")
        try {
            var userData = {
                "year": "",
                "start_date": "",
                "end_date": "",
                // "email": "",
                "sortby": "",
                "payment_status": ""
            }

            let responseData = await PaymentDetailService.index(userData).json()
            setPaymentList(responseData.data)
            setpackages(responseData.packages)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setkilometer(responseData.kilometer)
            setNumberOfNight(responseData.number_of_night);
            setisloading(false)


        } catch (error) {
            alert("An Error Occured.")
        }
    }
    const handleSortByFunction = async () => {

        var userData = {
            "year": selectedYear ? selectedYear : '',
            "sortby": "a-z",
        }

        let responseData = await PaymentDetailService.index(userData).json()
        setPaymentList(responseData.data)
        setpackages(responseData.packages)
        setcancaletions(responseData.cancaletions)
        setservices(responseData.services)
        setaccessories(responseData.accessories)
        setkilometer(responseData.kilometer)
        setNumberOfNight(responseData.number_of_night);
        setisloading(false)
    }

    const handlestartDateChange = (event) => {
        setStartDate(event.target.value);
    };
    const handleendDateChange = (event) => {
        setEndDate(event.target.value);
    };

     const handleKautionempfangen = async (orderid) => {
            try {
    
                let responseData = await PaymentDetailService.updateKautionempfangen(orderid).json()
                if (responseData.status === true) {
    
                    getPaymentList();
                }
            } catch (error) {
                if (error.name === 'HTTPError') {
                    const errorJson = await error.response.json();
                    setError('Failed to update review. Please try again.')
                }
            }
    }

    return (
        <>
            <MainPagetitle mainTitle="Manage Booking" pageTitle={'Manage Booking'} parentTitle={'Home'} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                        <h4 className="heading mb-0">Booking List</h4>
                                        <button class="btn btn-secondary btn-sm ms-1 ms-auto" onClick={() => setFilterModal(true)}> Filter</button>
                                        <button class="btn btn-secondary btn-sm ms-1" onClick={() => handleSortByFunction()}> Sort By Email</button>
                                        <button class="btn btn-info btn-sm ms-1" onClick={() => resetfilter(true)}> Reset Filter</button>
                                        <button onClick={useDownloadExcel} className="btn btn-primary btn-sm ms-1"> Export Excel </button>

                                    </div>

                                    <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", marginBottom: "20px", maxWidth: "150px" }}>
                                        <span><b>Year</b></span>
                                        <select
                                            style={{ maxWidth: '100px', marginLeft: '20px' }}
                                            className="form-control"
                                            id="val-skill"
                                            name="camper_id"
                                            // defaultValue={"all"}
                                            value={selectedYear} // Set the current selected year
                                            onChange={(e) => {
                                                setSelectedYear(e.target.value); // Update the selected year in state
                                                getdashboardByYear(e); // Call the handler to perform any additional actions
                                            }}
                                        >
                                            <option key="all" value="">All Years</option>
                                            {years.map((year) => (
                                                <>

                                                    <option key={year} value={year}>
                                                        {year}
                                                    </option>
                                                </>
                                            ))}
                                        </select>
                                    </div>

                                    <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                        <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0" ref={tableRef}>
                                            <thead>
                                                <tr style={{ textAlign: 'center' }}>
                                                    <th>No.</th>
                                                    <th>
                                                        <strong>Checked</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Deposit</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Type</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Booking Number</strong>
                                                    </th>
                                                    <th>
                                                        <strong>View Documents</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Camper Model</strong>
                                                    </th>
                                                    <th>
                                                        <strong>License Plate</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Number of Nights</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Carefree Package</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Cancellation Policy</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Services</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Accessoires</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Kilometer</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Start Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>End Date</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Billing User Name</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Billing Email</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Billing Amount</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Pays Cash (COD)</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Payment Status</strong>
                                                    </th>
                                                    <th>
                                                        <strong>First & Last Name</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Email</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Phone Number</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Date of Birth</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Street, Address Addition, Zip</strong>
                                                    </th>
                                                    <th>
                                                        <strong>City, Country</strong>
                                                    </th>
                                                    <th>
                                                        <strong>VAT ID</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Company</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Created</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Voucher?</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Resend Confirmation</strong>
                                                    </th>
                                                    <th style={{ textAlign: 'left' }}><strong >Action</strong></th>
                                                    <th>
                                                        <strong>Problems</strong>
                                                    </th>
                                                    <th>
                                                        <strong>General</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Tips</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Satisfied?</strong>
                                                    </th>
                                                    <th style={{ textAlign: 'center' }}>
                                                        <strong>Review</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Review Reminder #2</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Review Submitted</strong>
                                                    </th>
                                                    <th>
                                                        <strong>Deposit Refunded</strong>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    records.length > 0 ? (
                                                        records.map((element, index) => {

                                                            return (
                                                                <tr style={{ textAlign: 'center' }}>

                                                                    <td>
                                                                        <div className="products">
                                                                            <h6>{index + 1}</h6>
                                                                        </div>
                                                                    </td>

                                                                    <td>
                                                                        {/* {element.is_checked == 0 || element.ischecked == 1 ?  */}
                                                                        {element.is_checked == 0 ?
                                                                            <span className="btn btn-danger btn-sm ms-1">Not Checked</span>
                                                                            : element.is_checked == 1 ?
                                                                                <span className="btn btn-success btn-sm ms-1">Checked</span>
                                                                                : element.is_checked == 2 ?
                                                                                    <span className="btn btn-warning btn-sm ms-1">Pending</span> : ''}
                                                                        <Link id={element.order_id} onClick={updatechecktatus}> Change?   </Link>
                                                                    </td>
                                                                    <td>
                                                                        {element.deposit_received == 0 ?
                                                                            <span className="btn btn-danger btn-sm ms-1" onClick={() => handleKautionempfangen(element.order_id)}>Not received</span> :
                                                                            <span className="btn btn-success btn-sm ms-1" onClick={() => handleKautionempfangen(element.order_id)}>Received </span>}
                                                                        
                                                                    </td>
                                                                    <td style={{ color: '#3AC977' }}>{element.camper_type_id === 1 ? "Rent" : element.camper_type_id === 2 ? "Subscription" : "Sale"}</td>
                                                                    <td>{element.payment_order_id}</td>
                                                                    <td>    <button className="btn btn-primary btn-sm ms-1"
                                                                        onClick={() => navigate(`/admin/documents/${element.user_id}`)}>View Documents</button></td>
                                                                    <td>{element.camper_name}</td>
                                                                    <td>{element.license_plate}</td>
                                                                    <td>{numberOfNight[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{packages[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{cancaletions[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{services[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{accessories[index]}</td>
                                                                    <td style={{ whiteSpace: 'pre-line' }}>{kilometer[index]}</td>

                                                                    <td>{moment(element.start_date).format('DD.MM.YYYY HH:mm')}</td>
                                                                    <td>{moment(element.end_date).format('DD.MM.YYYY HH:mm')}</td>
                                                                    <td>{element.billing_user_name2 ? element.billing_user_name : '-'}</td>
                                                                    <td>{element.billing_email2 ? element.billing_email : '-'}</td>
                                                                    <td>{element.billing_amount}
                                                                        {element?.month_wise_price?.length > 0 && 
                                                                            <OverlayTrigger
                                                                                placement="top"
                                                                                overlay={
                                                                                    <Tooltip id="billing-tooltip" className="billing-tooltip">
                                                                                        <div className="text-start">
                                                                                            {element?.month_wise_price?.map((item) => (
                                                                                                <div
                                                                                                    key={item?.month}
                                                                                                    className="tooltip-row"
                                                                                                >
                                                                                                    <span>{item?.month} Month</span>
                                                                                                    <strong>{item?.price} €</strong>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </Tooltip>
                                                                                }
                                                                            >
                                                                                <span className="cursor-pointer">
                                                                                    <i
                                                                                        className="fa fa-info-circle"
                                                                                        style={{ marginLeft: "6px", cursor: "pointer" }}
                                                                                    ></i>
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                        }
                                                                    </td>
                                                                    <td>{element.COD == 1 ? 'Yes' : 'No'}</td>
                                                                    <td>
                                                                        {
                                                                            element.Paid == 1 && element.COD == 0 ?
                                                                                <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#006400", color: "#fff" }}>Fully Paid  (Stripe)</span>
                                                                                :
                                                                                element.Paid == 2 && element.COD == 1 ?
                                                                                    <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#FFA500", color: "#fff" }}>Partially Paid</span>
                                                                                    :
                                                                                    element.COD == 1 && element.Paid == 3 ?
                                                                                        <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Fully Paid (Manual)</span>
                                                                                        :
                                                                                        element.COD == 1 && element.Paid == 0 ?
                                                                                            <span className="btn btn-sm ms-1" style={{ backgroundColor: "#FF0000", color: "#fff" }}>Not Paid</span> :
                                                                                            ""
                                                                        }
                                                                        {element.Paid == 1 && element.COD == 0 ? "" : <Link id={element.payment_id}
                                                                            onClick={handlePaidStatus}> Change?</Link>}
                                                                    </td>
                                                                    {/* <td>{
                                                                        element.Paid == 1 && element.COD == 0 ?
                                                                            <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#006400", color: "#fff" }}>Fully Paid  (Stripe)</span>
                                                                            :  element.Paid == 0 ?
                                                                                <span className="btn btn-sm ms-1" style={{ backgroundColor: "#FF0000", color: "#fff" }}>Not Paid</span> :
                                                                                 element.Paid == 2 ?
                                                                                    <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#FFA500", color: "#fff" }}>Partially Paid</span>
                                                                                    :
                                                                                    element.Paid == 3 ?
                                                                                        <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Fully Paid (Manual)</span>
                                                                                        : element.COD == 1 ?
                                                                                            <span className="btn  btn-sm ms-1" style={{ backgroundColor: "#32CD32", color: "#fff" }}>Fully Paid (Manual)</span> : ""
                                                                    }
                                                                        {element.Paid == 1 && element.COD == 0 ? "" : <Link id={element.payment_id}
                                                                            onClick={handlePaidStatus}> Change?</Link>}
                                                                    </td> */}
                                                                    <td>{element.billing_user_name2}</td>
                                                                    <td>{element.billing_email2}</td>
                                                                    <td>{element.phone}</td>
                                                                    <td>{moment(element.dob).format('DD.MM.YYYY')}</td>

                                                                    <td>{element.paddress}</td>
                                                                    <td>{element.paddress_2}</td>
                                                                    <td>{element.pvat_id}</td>
                                                                    <td>{element.pcompany}</td>
                                                                    <td>{moment(element.order_created_at).format('DD-MM-YYYY HH:mm')}</td>
                                                                    <td>{element.ovouchercode ? <span className="btn btn-success btn-sm ms-1">Yes <br />{element.ovouchercode}</span> : <span className="btn btn-danger btn-sm ms-1">No</span>}</td>
                                                                    <td> <span className="btn btn-purple btn-sm ms-1" onClick={() => handleResendConfirmation(element.order_id)}>Resend</span></td>
                                                                    <td>
                                                                        <div className="d-flex">
                                                                            <Link
                                                                                className={`btn me-1 ${element.is_cancellations == 0 ? 'btn-danger' : 'btn-brown'
                                                                                    }`}
                                                                                id={element.order_id}
                                                                                // onClick={element.is_cancellations == 0 ? handleCancle : undefined}
                                                                                onClick={handleCancle}
                                                                                
                                                                            >
                                                                                {element.is_cancellations == 0 ? 'Cancel' : 'Cancelled'}
                                                                            </Link>
                                                                            <Link className="btn btn-primary me-1" id={element.payment_id} onClick={handleRefund}>{element.is_refunds == 0 ? 'Refund' : 'Refunded'}</Link>
                                                                            <Link
                                                                                onClick={() =>
                                                                                    swal({
                                                                                        title: "Are you sure?",
                                                                                        text: "Once deleted, you will not be able to recover this data!",
                                                                                        icon: "warning",
                                                                                        buttons: true,
                                                                                        dangerMode: true,
                                                                                    }).then((willDelete) => {
                                                                                        if (willDelete) {
                                                                                            (handleDelete(element.order_id));
                                                                                        }
                                                                                    })
                                                                                }

                                                                                className="btn btn-danger"
                                                                            >
                                                                                Delete
                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        {problem_comment == index ? (
                                                                            <>
                                                                                <input name="problem_comment"
                                                                                    defaultValue={inputproblem ? inputproblem : element.problem_comment}
                                                                                    onChange={(e) => setInputProblem(e.target.value)}

                                                                                />
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {
                                                                                    handleProblem_comment(element.order_id, "Problem_comment", inputproblem)
                                                                                    // element.problem_comment
                                                                                }
                                                                                }>Save</button>

                                                                            </>

                                                                        ) : (
                                                                            <div>
                                                                                <p>{element.problem_comment}</p>
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {

                                                                                    setProblem_comment(index)
                                                                                }
                                                                                }>Edit</button>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {general_comment == index ? (
                                                                            <>
                                                                                <input name="problem_comment"

                                                                                    defaultValue={element.general_comment} onChange={(e) => setInputgeneral(e.target.value)} />
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {
                                                                                    handleProblem_comment(element.order_id, "General_comment", element.general_comment)

                                                                                }
                                                                                }>Save</button>

                                                                            </>

                                                                        ) : (
                                                                            <div>
                                                                                <p>{element.general_comment}</p>
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {

                                                                                    setgeneral_comment(index)
                                                                                }
                                                                                }>Edit</button>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {tips_comment == index ? (
                                                                            <>
                                                                                <input name="tips_comment"
                                                                                    defaultValue={element.tips_comment} onChange={(e) => setInputtip(e.target.value)} />
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {
                                                                                    handleProblem_comment(element.order_id, "tips_comment", element.tips_comment)

                                                                                }
                                                                                }>Save</button>

                                                                            </>

                                                                        ) : (
                                                                            <div>
                                                                                <p>{element.tips_comment}</p>
                                                                                <button className="btn btn-success btn-sm ms-1" onClick={() => {

                                                                                    settips_comment(index)
                                                                                }
                                                                                }>Edit</button>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                     <td>
                                                                        {
                                                                            element.is_satisfied == 0 ?
                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleSatisfied(element.order_id, 1)}>Yes</span>
                                                                                :

                                                                                <span className="btn btn-brown btn-sm ms-1" onClick={() => handleSatisfied(element.order_id, 0)}>No</span>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            element.is_reviewed == 0 ?
                                                                                <span className="btn btn-danger btn-sm ms-1" onClick={() => handleReview(element.order_id)}>Not Requested</span>
                                                                                :

                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleReview(element.order_id)}>Requested</span>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            element.review_reminder_2 == 0 ?
                                                                                <span className="btn btn-danger btn-sm ms-1" onClick={() => handleReviewReminder(element.order_id, 1)}>Not Requested</span>
                                                                                :

                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleReviewReminder(element.order_id, 0)}>Requested</span>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            element.review_submitted == 0 ?
                                                                                <span className="btn btn-danger btn-sm ms-1" onClick={() => handleReviewSubmit(element.order_id, 1)}>Not Submitted</span>
                                                                                :

                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleReviewSubmit(element.order_id, 0)}>Submitted</span>
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            element.deposit_refunded == 0 ?
                                                                                <span className="btn btn-danger btn-sm ms-1" onClick={() => handleDepositRefund(element.order_id, 1)}>Not Refunded</span>
                                                                                :

                                                                                <span className="btn btn-success btn-sm ms-1" onClick={() => handleDepositRefund(element.order_id, 0)}>Refunded</span>
                                                                        }
                                                                    </td>


                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr style={{ textAlign: 'center' }}>

                                                            <td colSpan={12}>
                                                                <div className='text-center'>No records found</div>
                                                            </td>
                                                        </tr>

                                                    )
                                                }

                                            </tbody>

                                        </table>
                                        <div className="d-sm-flex text-center justify-content-between align-items-center">
                                            <div className='dataTables_info'>
                                                Showing {lastIndex - recordsPage + 1} to{" "}
                                                {Array.isArray(PaymentList) && PaymentList.length < lastIndex ? PaymentList.length : lastIndex}
                                                {" "}of {Array.isArray(PaymentList) ? PaymentList.length : 0} entries
                                            </div>
                                            <div
                                                className="dataTables_paginate paging_simple_numbers justify-content-center"
                                                id="example2_paginate"
                                            >
                                                <Link
                                                    className="paginate_button previous disabled"
                                                    to="#"
                                                    onClick={prePage}
                                                >
                                                    <i className="fa-solid fa-angle-left" />
                                                </Link>
                                                <span>
                                                    {number.map((n, i) => (
                                                        <Link className={`paginate_button ${currentPage === n ? 'current' : ''} `} key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}

                                                        </Link>
                                                    ))}
                                                </span>
                                                <Link
                                                    className="paginate_button next"
                                                    to="#"
                                                    onClick={nextPage}
                                                >
                                                    <i className="fa-solid fa-angle-right" />
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* FilterModal */}
            <Modal centered className="mark-attendence" show={FilterModal}>
                <Modal.Header>
                    <Modal.Title>Filter </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setFilterModal(false)}></Button>
                </Modal.Header>
                <Modal.Body>
                    <form className="form-valide" onSubmit={onSubmitFilterForm} >

                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card">

                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="val-username" className="form-label" >StartDate</label>
                                                <input type="date" className="form-control" name='start_date' id="val-username"
                                                    value={startDate} onChange={handlestartDateChange} />
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="val-username" className="form-label" >EndDate</label>
                                                <input type="date" className="form-control" name='end_date' id="val-username"
                                                    value={EndDate} onChange={handleendDateChange} />
                                            </div>
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="exampleFormControlInput2" className="form-label" >Payment Status</label>
                                                <select name="payment_status" value={paymentStatus} onChange={handlePaymentStatusChange} className="form-control">
                                                    <option key="" value="">Select Payment Status</option>
                                                    <option key="1" value="1">Fully Paid  (Stripe)</option>
                                                    <option key="0" value="0">Not Paid</option>
                                                    <option key="2" value="2">Partially Paid</option>
                                                    <option key="3" value="is_cod">Fully Paid (Manual)</option>
                                                </select>

                                            </div>
                                            {/* 
                                            <div className="col-xl-12 mb-3">
                                                <label htmlFor="val-username" className="form-label" >Email</label>
                                                <input type="email" className="form-control" name='email' id="val-english_message"
                                                />
                                            </div> */}

                                        </div>

                                        <div>
                                            <button type="submit" className="btn btn-primary me-1">Submit</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>

                </Modal.Body>

            </Modal>

            <Modal centered className="mark-attendence" show={ResendModal}>
                <Modal.Header>
                    <Modal.Title>Saved </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setResendModal(false)}></Button>
                </Modal.Header>
                <Modal.Body>Email sent successfully!</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to='/admin/payment_details' variant="danger light" onClick={() => setResendModal(false)}>Close</Link>
                </Modal.Footer>
            </Modal>
            <Modal centered className="mark-attendence" show={UpdateReview}>
                <Modal.Header>
                    <Modal.Title>Saved </Modal.Title>
                    <Button variant="" className="btn-close" onClick={() => setUpdateReview(false)}></Button>
                </Modal.Header>
                <Modal.Body>{modalMessage}</Modal.Body>
                <Modal.Footer>
                    <Link className="btn btn-primary" to='/admin/payment_details' variant="danger light" onClick={() => setUpdateReview(false)}>Close</Link>
                </Modal.Footer>
            </Modal>

            {/* Cancellation Modal */}
            <Modal
                centered
                size="lg"
                show={conflictModal}
                onHide={() => setConflictModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Date Conflict</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {/* Error Message */}
                    <div className="alert alert-danger mb-4">
                        This booking cannot be restored because some dates are already booked.
                    </div>

                    {/* Requested Dates */}
                    {conflictData?.requested && (
                        <>
                            <h6 className="fw-semibold mb-2">Requested Dates</h6>
                            <table className="table table-bordered table-sm mb-4">
                                <thead className="table-light">
                                    <tr>
                                        <th>From</th>
                                        <th>To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{conflictData.requested.from ? moment(conflictData.requested.from).format('DD.MM.YYYY HH:mm') : ''}</td>
                                        <td>{conflictData.requested.to ? moment(conflictData.requested.to).format('DD.MM.YYYY HH:mm') : ''}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    )}

                    {/* Conflicting Booking */}
                    {conflictData?.conflicts?.length > 0 && (
                        <>
                            <h6 className="fw-semibold mb-2 text-danger">
                                Conflicting Booking
                            </h6>
                            <table className="table table-bordered table-sm mb-4">
                                <thead className="table-light">
                                    <tr>
                                        <th>From</th>
                                        <th>To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {conflictData.conflicts.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.from ? moment(item.from).format('DD.MM.YYYY HH:mm') : ''}</td>
                                            <td>{item.to ? moment(item.to).format('DD.MM.YYYY HH:mm') : ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    )}

                    {/* Available Dates */}
                    {conflictData?.available?.length > 0 ? (
                        <>
                            <h6 className="fw-semibold mb-2 text-success">
                                Available Alternative Dates
                            </h6>
                            <table className="table table-bordered table-sm">
                                <thead className="table-light">
                                    <tr>
                                        <th>From</th>
                                        <th>To</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {conflictData.available.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item.from ? moment(item.from).format('DD.MM.YYYY HH:mm') : ''}</td>
                                            <td>{item.to ? moment(item.to).format('DD.MM.YYYY HH:mm') : ''}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    ) : (
                        <div className="alert alert-warning mt-3">
                            No alternative dates available.
                        </div>
                    )}
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary" onClick={() => setConflictModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>



            {isLoading && <LogoAnimationLoader />}

        </>
    );
};

export default PaymentDetailList;
